import React from "react";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { GET_FINANCIALS } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Refernearn = () => {
  const [SidebarState, setSidebarState] = useState(false);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
  };

  const copyReferralLink = () => {
    const referralLink = document.getElementById("referral-link");
    referralLink.select();
    document.execCommand("copy");
    alert("Referral link copied to clipboard!");
  };

  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content">
          <div className="container mt-3">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h2 className="text-center mb-3 text-primary">
                  Refer and Earn
                </h2>
                <div className="card shadow border-0">
                  <div className="card-body">
                    <h4 className="card-title text-center">Refer a Friend</h4>
                    <p className="text-center">
                      Share your referral link with friends and earn rewards
                      when they sign up!
                    </p>
                    <div className="row justify-content-center">
                      <div className="col-md-8">
                        <div className="form-group">
                          <label>Your Referral Code: {user.id}</label>
                        </div>
                        <div className="form-group">
                          <label>Your Referral Link:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="referral-link"
                            value={`https://markettrade.live/register-now/?code=${user.id}`}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row justify-content-center mt-3">
                      <div className="col-md-8">
                        <button
                          className="btn btn-primary btn-block"
                          onClick={copyReferralLink}
                        >
                          Copy Referral Link
                        </button>
                      </div>
                    </div>
                    <div className="row justify-content-center mt-4">
                      <div className="col-md-8">
                        <h5 className="text-center mb-3">
                          Or Share on Social Media
                        </h5>
                        <div className="d-flex justify-content-between">
                          <a
                            href={`https://www.facebook.com/sharer/sharer.php?u=https://markettrade.live/register-now/${user.id}`}
                            target="_blank"
                            className="btn btn-outline-primary me-1"
                          >
                            <i className="fab fa-facebook-f"></i> Share on
                            Facebook
                          </a>
                          <a
                            href={`https://twitter.com/intent/tweet?url=https://markettrade.live/register-now/${user.id}&text=Check%20out%20this%20link%20to%20join%20me%20on%20MarketTrade!`}
                            target="_blank"
                            className="btn btn-outline-info me-1"
                          >
                            <i className="fab fa-twitter"></i> Share on Twitter
                          </a>
                          <a
                            href={`https://wa.me/?text=Check%20out%20this%20link%20to%20join%20me%20on%20MarketTrade!%20https://markettrade.live/register-now/${user.id}`}
                            target="_blank"
                            className="btn btn-outline-success me-1"
                          >
                            <i className="fab fa-whatsapp"></i> Share on
                            WhatsApp
                          </a>
                          <a
                            href={`https://www.linkedin.com/sharing/share-offsite/?url=https://markettrade.live/register-now/${user.id}`}
                            target="_blank"
                            className="btn btn-outline-primary"
                          >
                            <i className="fab fa-linkedin-in"></i> Share on
                            LinkedIn
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="mt-5">
                        <div className="bg-primary text-white text-center">
                          <h3>Details</h3>
                        </div>
                        <div className="text-center">
                          <h3>Earn Commission & Salary Together!</h3>
                          <p className="fw-bold">
                            Clients with 1000/month commission are called Active
                            Clients
                          </p>
                        </div>
                        <div className="card-body">
                          <table className="table table-bordered">
                            <thead className="table-dark">
                              <tr>
                                <th scope="col">Level</th>
                                <th scope="col">Designation</th>
                                <th scope="col">No. of Clients</th>
                                <th scope="col">Salary + Commission</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>1</td>
                                <td>Silver</td>
                                <td>1 to 5</td>
                                <td>10%</td>
                              </tr>
                              <tr>
                                <td>2</td>
                                <td>Gold</td>
                                <td>6 to 10</td>
                                <td>20% + Salary (As per terms)</td>
                              </tr>
                              <tr>
                                <td>3</td>
                                <td>Platinum</td>
                                <td>11 to 25</td>
                                <td>30% + Salary (As per terms)</td>
                              </tr>
                              <tr>
                                <td>4</td>
                                <td>Diamond</td>
                                <td>26 to 50</td>
                                <td>40% + Salary (As per terms)</td>
                              </tr>
                              <tr>
                                <td>5</td>
                                <td>Legend</td>
                                <td>51 and Above</td>
                                <td>50% + Salary (As per terms)</td>
                              </tr>
                            </tbody>
                          </table>
                          <div
                            className="alert alert-info mt-4"
                            role="alert"
                          ></div>
                          <strong>Note:</strong> Salary Calculation will be done
                          by multiply 1000 and No. of Active clients (with
                          10000/month or above commission). For more details
                          check example below
                        </div>
                        <div className="alert alert-success">
                          <h5>Example:</h5>
                          <p>
                            You are on Level 2 and designation Gold along with
                            11 active clients in a month, then ₹11,000 + 30%
                            commission.
                          </p>
                        </div>
                        <ul className="list-group mt-4">
                          <li className="list-group-item">
                            - Current Month commission will be calculated on the
                            basis of Max Level achieved in last month.
                          </li>
                          <li className="list-group-item">
                            - You will be promoted to next level once Active
                            Client target achieved for next level.
                          </li>
                          <li className="list-group-item">
                            - In case Higher level is achieved anytime in month
                            then commission will be calculated on the basis of
                            new level.
                          </li>
                          <li className="list-group-item">
                            - Salary will be provided monthly.
                          </li>
                          <li className="list-group-item">
                            - Salary will be credited on first day of next
                            month.
                          </li>
                          <li className="list-group-item">
                            - Commission sharing can be withdrawn any time.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Refernearn;
